import { DatePicker, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { FC, useEffect, useState } from 'react';
import { IPOButton, IPOInput, IPOSelect } from '@hylaa-npm/ipod';

import { CustomSelect } from '@/styles/components/CustomSelect';
import SelectNode from '../SelectEl';

import { PSearchToolWrap } from './style';

export enum SearchEnum {
	INPUT = 'INPUT',
	SELECT = 'SELECT',
	SELECT_SEARCH = 'SELECT_SEARCH',
	DATE_PICKER = 'DATE_PICKER',
}

// 出参
export interface IValueProps {
	[key: string]: string;
}

export interface ISearchTool {
	key: string;
	placeholder: string;
	type: SearchEnum;
	defaultValue?: string;
	selectData?: {
		seleceKey: string;
		selectLabel: string;
		selectTree: {
			[key: string]: string;
		}[];
		isSearch?: boolean;
	};
}

// 入参
interface IPSearchToolProps {
	tools: ISearchTool[];
	handleSearch: (value: IValueProps) => void;
}

export const PSearchTool: FC<IPSearchToolProps> = ({ tools, handleSearch }) => {
	const { Option } = CustomSelect;
	const { RangePicker } = DatePicker;
	const { t } = useTranslation();
	const [searchForm] = Form.useForm();

	const [info, setInfo] = useState<IValueProps>({});

	useEffect(() => {
		clearData();
	}, [JSON.stringify(tools)]);

	useEffect(() => {
		const initForm: IValueProps = {};
		tools.forEach((tool) => {
			initForm[tool.key] = tool.defaultValue ?? '';
		});

		searchForm.setFieldsValue(initForm);
	}, []);

	const clearData: () => void = () => {
		const copyInfo: IValueProps = {};
		const dateTool = tools.filter((item) => item.type === SearchEnum.DATE_PICKER);
		if (dateTool.length > 0) {
			copyInfo.startTime = '';
			copyInfo.endTime = '';
		}
		tools.forEach((tool) => {
			copyInfo[tool.key] = '';
		});
		setInfo(copyInfo);
		searchForm.setFieldsValue(copyInfo);
		handleSearch(copyInfo);
	};

	return (
		<PSearchToolWrap>
			<div className="tools-title">{t('project.searchCriteria')}</div>
			<div className="tools-content">
				<div className="tools--wrap">
					{tools.map((tool) => {
						const { key, placeholder, type, selectData } = tool;
						return (
							<Form className="tool-item" form={searchForm} key={tool.key}>
								{type === SearchEnum.INPUT && (
									<Form.Item name={[key]}>
										<IPOInput
											allowClear={false}
											placeholder={placeholder}
											onChange={(node: { target: { value: string } }) =>
												setInfo({ ...info, [key]: node.target.value })
											}
										/>
									</Form.Item>
								)}
								{type === SearchEnum.SELECT && (
									<Form.Item name={[key]}>
										{
											<SelectNode
												isSearch={selectData?.isSearch}
												selectData={selectData}
												onChange={(value) => setInfo({ ...info, [key]: value as string })}
											/>
										}
									</Form.Item>
								)}
								{type === SearchEnum.DATE_PICKER && (
									<Form.Item name={[key]}>
										<RangePicker
											suffixIcon={
												<div>
													<i className="icon-calendar" />
												</div>
											}
											separator="~"
											onChange={(moments) => {
												setInfo({
													...info,
													startTime: moments
														? dayjs(moments[0]).startOf('date').valueOf().toString()
														: '',
													endTime: moments
														? dayjs(moments[1]).startOf('date').add(24, 'hour').valueOf().toString()
														: '',
												});
											}}
										/>
									</Form.Item>
								)}
								{type === SearchEnum.SELECT_SEARCH && (
									<Form.Item name={[key]}>
										<IPOSelect
											showSearch
											dropdownMatchSelectWidth={false}
											onChange={(value) => setInfo({ ...info, [key]: value as string })}>
											{selectData?.selectTree.map((selectItem) => (
												<Option
													value={selectItem[selectData?.seleceKey]}
													key={selectItem[selectData?.seleceKey]}>
													{selectItem[selectData?.selectLabel]}
												</Option>
											))}
										</IPOSelect>
									</Form.Item>
								)}
							</Form>
						);
					})}
				</div>
				<div className="btn--wrap">
					<IPOButton
						type="ghost"
						style={{ background: '#fff', borderRadius: '2px' }}
						onClick={() => clearData()}>
						{t('project.empty')}
					</IPOButton>
					<IPOButton
						type="primary"
						style={{ borderRadius: '2px' }}
						onClick={() => handleSearch(info)}>
						{t('project.search')}
					</IPOButton>
				</div>
			</div>
		</PSearchToolWrap>
	);
};
